import React, { FC } from 'react'
import { AlertComponentPropsWithStyle } from 'react-alert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Alert: FC<AlertComponentPropsWithStyle> = (props) => {
  const {
    style,
    options,
    message,
    close,
  } = props

  const getIconClass = () => {
    if (options.type === 'success') {
      return 'fa-check-circle'
    }
    if (options.type === 'info') {
      return 'fa-info-circle'
    }
    if (options.type === 'error') {
      return 'fa-exclamation-circle'
    }
    return ''
  }

  return (
    <div
      className={`alert alert-${options.type}`}
      style={{ ...style }}
    >
      <button
        type="button"
        className="close"
        onClick={close}
      >
        <FontAwesomeIcon icon={['fas', 'times']} />
      </button>
      {
        options.type && (
          <div
            className={`fa ${getIconClass()}`}
            style={{ marginRight: '16px' }}
          />
        )
      }
      <div>
        {message}
      </div>
    </div>
  )
}

export default Alert
